<script>
	export default {
		props: {
			leaflet: {
				type: Object,
				required: true
			},
			map: {
				type: Object,
				required: true
			},
			backgroundLayer: {
				type: Object,
				required: true
			}
		},
		watch: {
			'backgroundLayer': {
				handler: 'addLayer',
				immediate: true
			}
		},
		created() {
			this.$once('hook:beforeDestroy', () => {
				if (this._currentLayer)
					this.map.removeLayer(this._currentLayer);
			})
		},
		render() {
			return this.$slots.default;
		},
		methods: {
			addLayer() {
				if (this._currentLayer)
					this._currentLayer.remove();

				if (!this.backgroundLayer || !this.backgroundLayer.url)//обработка для ПУСТОГО слоя подложки
					return;

				const options = {
					updateWhenZooming: false,
					attribution: this.backgroundLayer.copyright,
                    zIndex:0,
                    maxZoom: this.map.options.maxZoom
				};

				this._currentLayer = this.leaflet.tileLayer(this.backgroundLayer.url, options);
				this._currentLayer.addTo(this.map);
			}
		}
	}
	;
</script>
